import { render } from "./ProductBreadcrumb.vue?vue&type=template&id=c33f5070"
import script from "./ProductBreadcrumb.vue?vue&type=script&lang=js"
export * from "./ProductBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__